import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { homeProblems } from '../../data/landing';
export function HomeProblems() {
  return <section className="bg-white" data-id="element-224" data-mp="3tus8qvqj5gew">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20" data-id="element-225" data-mp="3tv1xkfzu9hj0">
        <SectionHeading title={<>Does this sound like <em className="text-coral" data-id="element-227" data-mp="3p1z1a03oftz4">your home?</em></>} data-id="element-226" data-mp="3p31uwfsdwaiq" />

        <ul className="mt-10 divide-y divide-navy/10 overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-228" data-mp="6p18cd5ay1eg">
          {homeProblems.map(p => {
          const Icon = p.icon;
          return <li key={p.title} className="flex gap-4 p-5 sm:p-7" data-id="element-229" data-mp="go06v2wcsgnq">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-coral-soft text-coral-dark" data-id="element-230" data-mp="bonmcosyflob">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-231" data-mp="2ieljaq00t6xq" />
                </span>
                <div data-id="element-232" data-mp="2dga748m96kcc">
                  <h3 className="text-lg font-black leading-snug text-navy sm:text-xl" data-id="element-233" data-mp="2dh23vmrl6o47">{p.title}</h3>
                  {p.chips.length > 0 && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-234" data-mp="rtly973mx0zs">
                      {p.chips.map(c => <li key={c} className="rounded-full bg-white px-3 py-1 text-sm font-bold text-navy" data-id="element-235" data-mp="10weod712z6o1">{c}</li>)}
                    </ul>}
                  <p className="mt-2 text-base leading-relaxed text-muted sm:text-[17px]" data-id="element-236" data-mp="15p7tvx4dij16">{p.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-237" data-mp="1fjpzj7tcoonm">
          <CTAButton label="I want to stop starting from zero" data-id="element-238" data-mp="1fn3z68amqjrd" />
        </div>
      </div>
    </section>;
}